import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;

//获取台账列表
export const standingBookList = params => {
    return axios.post(`${base}/api/Ledger/PostSelectLedgerList`, params);
}
//导出台账列表
export const exportStandingBook = params => {
    return axios.post(`${base}/api/Ledger/PostExportLedgerExcel`, params, { responseType: 'blob' });
}
//查询台账详情
export const checkStandingBookDetail = params => {
    return axios.get(`${base}/api/Ledger/GetSelectLedgerDetail`, { params: params });
}
//查询场馆列表不分页
export const getStadiumData = (params) => {
    return axios.get(`${base}/api/Venue/GetVenueListData`, { params: params });
};
//获取订场列表不分页
export const getCourtData = (params) => {
    return axios.get(`${base}/api/Venue/GetVenueCourtListData`, {
        params: params,
    });
};
//获取场地列表不分页
export const getSiteData = (params) => {
    return axios.get(`${base}/api/Venue/GetVenueCourtSiteListData`, {
        params: params,
    });
};